import React from 'react'
import classes from './ErrorPage.module.scss'
import Typography from '@/components/ui/Typography'
import { useErrorMessage } from '@/app/routes/ErrorPage/ErrorPage.hooks'
import { Link } from 'react-router-dom'

const ErrorPage = () => {
  const message = useErrorMessage()

  return (
    <div className={classes.root}>
      <Typography variant={'xxl'}>{message}</Typography>
      <Link to={'/dashboard'}>Go to home page</Link>
    </div>
  )
}

export default ErrorPage
